export default "__VITE_ASSET__6elmyp$szyRq84q$yn_H8w__"